import store from '@/store'

export default {
  allCampaigns (to, from, next) {
    let queryParams = {}
    store.dispatch('campaigns/query', {
      sort: 'createdAt DESC',
      ...to.query,
      ...queryParams
    })
      .then(response => {
        next()
      })
      .catch(e => {
        console.log(e)
      })
  },
  recentCampaigns (to, from, next) {
    store.dispatch('campaigns/query', {...to.query, limit: 10, sort: 'createdAt DESC'})
      .then(response => {
        next()
      })
      .catch(e => {
        console.log(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/guards/campaigns.guards.js